export const MAIN_MENU = 1;
export const SUB_MENU = 2;

export const PROPERTY_PROVIDE = ['ランチ', 'クーポン', '定食', 'サービス'];
export const PROPERTY_LIMIT = ['年齢制限', '終売', '店員呼出'];
